import React, { Component, Fragment } from 'react';
import ReactDOM from 'react-dom';
import {Link, withRouter} from "react-router-dom";

import Button2 from './Button2';
import SolicitudEvaluacion from './SolicitudEvaluacion';
import {refreshToken, downPayment, generatePaymentUrl} from '../api.js';
import BreadCrumb from './BreadCrumb';
import ContentBox from './ContentBox.js';
import {urls} from '../config.js';
import moment from 'moment';
import flechaIzquierdaNegra from '../img/arrow_left_black.svg';

class Requerimiento extends Component {
	constructor(props) {
		super(props);
		this.state = {
			evaluation_opened: false,
			loading: false,
			patente: null,
			caseResponseMap: {
				caseTitle: null,
				caseNumber: null,
				caseStatus: null,
				caseSFStatus: null,
				caseOrigin: null,
				createdDate: null,
				rangeResponse: null,
				contactEmail: null,
				contactPhone: null,
				description: null,
				showDescription: false,
				descriptionResult: null
			}
		};
	}
	componentDidMount() {
		this.props.changeHeaderClass("medium");
		this.mapRequest();
	}
	mapRequest() {
		const {slaDays, bussines_lines_name, id, status, origin, created_at_date, contactEmail, contactPhone, plazo_maximo_respuesta} = this.props.dataRequest;
		const mapCaseStatus = {
			Nuevo: "En proceso",
			Pendiente: "En proceso",
			"En tramite": "En proceso",
			"En Trámite": "En proceso",
			Cerrado: "Cerrado",
		}
		const mapCaseDescription = {
			Nuevo: `Nuestro equipo está analizando todos los antecedentes, con el fin de poder brindarle una respuesta en un plazo máximo de ${ slaDays ?? "algunos"} días hábiles.`,
			Pendiente: "El caso requiere información o documentación de tu parte. Revisa los comentarios en el correo enviado por el ejecutivo para conocer qué necesitamos para continuar. Si no lo encuentras, por favor revisa también tu bandeja de spam o correo no deseado.",
			"En tramite": "Nuestro equipo se encuentra revisando los antecedentes para entregarte una respuesta. Te pedimos estar atento a tu correo y/o teléfono registrado, ya que podríamos solicitar información adicional.",
			"En Trámite": "Nuestro equipo se encuentra revisando los antecedentes para entregarte una respuesta. Te pedimos estar atento a tu correo y/o teléfono registrado, ya que podríamos solicitar información adicional.",
			Cerrado: "La respuesta de tu caso fue enviada al correo electrónico asociado. En caso de no encontrarla, por favor revisa también tu carpeta de spam."
		}
		const mapRangeResponse = plazo_maximo_respuesta ? moment(plazo_maximo_respuesta, "YYYY-MM-DD").format("DD-MM-YYYY") : null;

		this.setState({
			solicitud: this.props.dataRequest,
			caseResponseMap : {
				caseTitle: bussines_lines_name,
				caseNumber: id,
				caseStatus: mapCaseStatus[status] ?? "En proceso",
				caseSFStatus: status,
				caseOrigin: origin,
				createdDate: created_at_date,
				rangeResponse: mapRangeResponse,
				contactEmail: contactEmail,
				contactPhone: contactPhone,
				description: mapCaseDescription[status],
				showDescription: Object.hasOwn(mapCaseDescription,status),
				descriptionResult: null,
			}
		});
	}
	// renderFields() {
	// 	if(!this.state.solicitud ) return;
	// 	var created_at = moment(this.state.solicitud.created_at);
	// 	var groups = [];
	// 	var headerFields = [];
	// 	if(this.state.patente) headerFields.push({type:"text", label: "Patente", value: this.state.patente});
	// 	if(this.state.solicitud.term) headerFields.push({type:"text", label: "Plazo de respuesta", value: moment(this.state.solicitud.term, "YYYY-MM-DD").format("DD-MM-YYYY")});		
		
	// 	[...headerFields, ...this.state.solicitud.data].forEach((field) => {
	// 		let elemntFileDownload = null;
			
	// 		if(field.element === "textarea") {
	// 			return groups.push(
	// 				<div>
	// 					<b>{field.label}</b>
	// 					{field.value}
	// 				</div>
	// 			);
	// 		}
	// 		if(field.type === "file" && !created_at.isBetween('2020-04-14', '2020-06-23')) {
	// 			elemntFileDownload = 
	// 				< PostFileDownload 
	// 					value={field.value} 
	// 					request_id={this.props.request_id} 
	// 					field_name={field.name} 
	// 					filename={field.file_name}
	// 					is_sf={Number(this.props.location.is_sf)} 
	// 					isCompany={Boolean(this.state?.solicitud?.company_user_id)}
	// 				/>;
	// 		}

	// 		groups.push(
	// 			<p key={field.name?field.name:"id"}>
	// 				{field.label} : 
	// 				{  elemntFileDownload ?? <span> {field.value} </span> }
	// 			</p>				
	// 		);
	// 	});

	// 	return groups;
	// }
	closeSolicitud(){
		this.mapRequest();
		this.setState({evaluation_opened: false})
	}
	renderAgreement(){
		let agreement = this.state.solicitud.agreement;
		
		return(
			<div className="solicitud-detalle-fields col-100 left clearfix">				
				<h2 className="uppercase clearfix"><strong style={{marginBottom: '30px'}} className="color-black bold col-100 left">Convenio Solicitado</strong></h2>			
				<div className="solicitud-detalle-field">
					<div className="solicitud-detalle-label">
						<p>Deuda vigente</p>
					</div>
					<div className="solicitud-detalle-value">
						<p>${parseInt(agreement.current_debt).toLocaleString("de")}</p>
					</div>
				</div>
				<div className="solicitud-detalle-field">
					<div className="solicitud-detalle-label">
						<p>Pie</p>
					</div>
					<div className="solicitud-detalle-value">
						<p>${parseInt(agreement.down_payment).toLocaleString("de")}</p>
					</div>
				</div>
				<div className="solicitud-detalle-field">
					<div className="solicitud-detalle-label">
						<p>Saldo a pagar en cuotas</p>
					</div>
					<div className="solicitud-detalle-value">
						<p>${(parseInt(agreement.current_debt) - parseInt(agreement.down_payment)).toLocaleString("de")}</p>
					</div>
				</div>
				<div className="solicitud-detalle-field">
					<div className="solicitud-detalle-label">
						<p>Cuotas</p>
					</div>
					<div className="solicitud-detalle-value">
						<p>{agreement.payments}</p>
					</div>
				</div>
				{this.renderAgreementState(agreement)}				
			</div>
		);
	}
	downPayment(status){
		this.setState({loading: true});
		downPayment(this.props.request_id, (error, result) => {
			this.setState({loading: false});
			if(typeof(error) != 'undefined' && error != null) {
				console.log("ocurrio un error con el request");
			}
			if(typeof(result) != 'undefined' && result != null && result.status === 'error') {
				this.props.createActionNotification("", result.message, "error");
				return console.log("ocurrio un error con el request");
			}
			if(typeof(result) != 'undefined' && result != null && result.status === 'ok'){
				const codCliente = Number(this.state.solicitud.agreement.abastible_contract_id).toString();
				generatePaymentUrl('MEDIDOR', {
					codCliente: codCliente,
					pie: 'true',
				}, (err, urlResult) => {
					if (err || !urlResult || urlResult.status !== 'ok') {
						console.error('Error al generar URL de pago pie', err);
						return;
					}
					window.open(urlResult.encryptedUrl, '_blank');
				});
			}
		});
		
	}
	renderAgreementState(agreement){
		
		if(this.state.solicitud.status === "Cerrado"){
			if(this.state.solicitud.clossing_justification === "Z0000001"){
				if(agreement.status === "Pagado"){
					return(
						<div className="subcontent-box solicitud-respuesta margin-top-30">
							<div className="solicitud-detalle-status-container">
								<div>
									<h3 className="solicitud-detalle-status-title">Se ha registrado el pago del pie. Puedes verificar el estado de tu convenio en la sección "Convenios"</h3>
								</div>
							</div>
						</div>
					);
				} else if(agreement.status === "Pendiente creación SAP" || agreement.status === "Error anulación" || agreement.status === "Creado SAP" || agreement.status === 'Anulado') {
					return(
						<div className="subcontent-box solicitud-respuesta margin-top-30">
							<div className="solicitud-detalle-status-container">
								<div>
									<h3 className="solicitud-detalle-status-title">Tu solicitud ha sido aprobada{this.state.solicitud.agreement_validity ? " y será válida hasta el " + moment(this.state.solicitud.agreement_validity, "YYYY-MM-DD").format("DD-MM-YYYY") : null}. Presiona el botón "crear convenio" para dar curso al pago del pie.</h3>
									<div className="margin-top-30">
										<Button2 label="Crear Convenio de Pago" className="orange" onClick={()=>{this.downPayment(agreement.status)}} />
									</div>
								</div>
							</div>
						</div>
					);
				} else {
					return null;
				}
			}
			if(this.state.solicitud.clossing_justification === "Z0000003"){
				return(
					<div className="subcontent-box solicitud-respuesta margin-top-30">
						<div className="solicitud-detalle-status-container">
							<div>
								<h3 className="solicitud-detalle-status-title">Su solicitud de convenio de pago ha sido rechazada. {this.state.solicitud.respuesta ? this.state.solicitud.respuesta : null}</h3>
							</div>
						</div>
					</div>
				);
			}
		}
	}
	render() {
		var breadCrumbOptions = [ {title: "Mis Requerimientos", to: "/requerimientos"}, {title: "Detalle de Requerimiento"} ];

		return (
				<Fragment>
					<div className="section-title">
						<h1>Mis Casos</h1>
						<BreadCrumb options={breadCrumbOptions} />
					</div>
					<ContentBox loading={this.state.loading} className="solicitud-distribuidor">
						<Link to={{pathname:"/requerimientos"}}>
							<div className="d-flex gap-2 uppercase color-black">
								<img alt="Atrás" src={flechaIzquierdaNegra}/>
								<p>atrás</p>
							</div>
						</Link>

						<div className="mt-24 d-flex">
							<h2 className='col-100'>
								<strong className="color-black bold col-100 left font-32-important">
									{this.state.caseResponseMap.caseTitle }
								</strong>
								{this.state.solicitud && 
									<span className='color-gray uppercase font-18'>
										N° CASO &nbsp;
										{this.state.caseResponseMap.caseNumber}
									</span>	
								}
							</h2>

							{ this.state.solicitud && 
								<div className="detalle-requerimiento--status-solicitud width-full-important-mobile max-width-unset-mobile mt-24-mobile flex-mobile flex-column felx-align-items-center">
									<h3> Estado del requerimiento </h3>

									{this.state.caseResponseMap.caseStatus &&
										<ChipStatus statusSF={this.state.caseResponseMap.caseSFStatus}>
											{this.state.caseResponseMap.caseStatus}
										</ChipStatus>
									}
								</div>
							}
						</div>


						<div className='mt-24 detalle-requerimiento--box-container-field'>
							<p className='width-full-important-mobile'>
								Caso ingresado desde:&nbsp;
								<span>
									{this.state.caseResponseMap.caseOrigin}
								</span>
							</p>

							<p className='width-full-important-mobile'>
								Creado:&nbsp;
								<span>
									{moment(this.state.caseResponseMap.createdDate, "YYYY-MM-DD").format("DD-MM-YYYY")}
								</span>
							</p>

							<p className={this.state.caseResponseMap.rangeResponse?'hidden-mobile ':''+'width-full-important-mobile'}>
								{this.state.caseResponseMap.rangeResponse && <>
									Plazo máximo de respuesta:&nbsp;
									<span>
										{this.state.caseResponseMap.rangeResponse}
									</span> 
								</>}
							</p>

							<p className='width-full-important-mobile'>
								Nombre contacto:&nbsp;
								<span>
									{this.props.user.name + " " +  this.props.user.last_name }
								</span>
							</p>

							<p className='width-full-important-mobile'>
								Email:&nbsp;
								<span>
									{this.state.caseResponseMap.contactEmail}
								</span>
							</p>

							<p className='width-full-important-mobile'>
								Teléfono:&nbsp;
								<span>
									{this.state.caseResponseMap.contactPhone}
								</span>
							</p>

							{this.state.caseResponseMap.showDescription && 
								<div>
									<b> Descripción </b>

									<pre className='text-wrap'>
										{this.state.caseResponseMap.description}
									</pre>
								</div>
							}


							{ this.state.caseResponseMap.descriptionResult && this.state.caseResponseMap.caseSFStatus !== "Cerrado" &&
								<div>
									<b> Detalle de Resolución </b>

									{this.state.caseResponseMap.descriptionResult}
								</div>
							}
						</div>

						{ this.state.solicitud && 
						!this.state.solicitud.agreement && 
						this.state.solicitud.respuesta && 
						this.state.solicitud.term &&
						new Date(this.state.solicitud.term).getTime() >= new Date("2020-09-01").getTime() &&
							<div className="subcontent-box solicitud-respuesta margin-top-30">
								<div>
									<div className="solicitud-detalle-value">
										<p>Respuesta</p>
									</div>
									<div className="solicitud-detalle-label">
										<p>{this.state.solicitud.respuesta}</p>
									</div>

									{this.state.solicitud.status === "Cerrado" && !this.state.solicitud.calificacion ?

									<Button2 label="Calificar" className="orange" onClick={()=>{this.setState({evaluation_opened: true})}} /> : null}
								</div>
							</div>
						}
						{this.state.solicitud && this.state.solicitud.agreement ? this.renderAgreement() : null}
						
						<p className='mt-24 color-gray text-center'>
							En Abastible estamos trabajando día a día con el objetivo de mejorar tu experiencia.
						</p>
					</ContentBox>
					{this.state.evaluation_opened ? <SolicitudEvaluacion request_id={this.props.request_id} close={() => this.closeSolicitud()} /> : null}
				</Fragment>
		);
	}
}

export class PostFileDownload extends Component {
	constructor(props) {
		super(props);
		this.state = {
			token: ""
		};
	}
	download() {
		refreshToken((error, result) => {
			if(error) return alert("Error descargando el archivo");
			this.setState({token: result.data.token}, () => {
				this._form.submit();
			});
		});
	}
	attachNode(node) {
    	this._form = ReactDOM.findDOMNode(node);
  	}
	render() {
		return (
			<div className="linkA-container" onClick={() => this.download()}>
				<form ref={this.attachNode.bind(this)}
				method="POST" action={urls.backend + `${this.props.isCompany ? "/company_user" : ""}/request/file`}>
					<input type="hidden" name="request_id" value={this.props.request_id} />
					<input type="hidden" name="is_sf" value={this.props.is_sf} />
					<input type="hidden" name="token" value={this.state.token} />
					<input type="hidden" name="name" value={this.props.field_name} />
				</form>
				<a><strong>{this.props.filename}</strong></a>
			</div>
		);
	}
}

export default withRouter(Requerimiento);


/**
* Componente que muestra el estado de un requerimiento.
*
* @class ChipStatus
* @extends Component
*
* @param {Object} props - Propiedades del componente.
* @param {React.ReactNode} props.children - Texto que describe el mensaje.
* @param {string} props.statusSF - propiedad original del estado segun SF.
*
* @example
*	<ChipStatus>
*		Nuevo
*	<ChipStatus/>
*/
class ChipStatus extends Component {
	constructor(props){
		super(props);
		this.state = {
			isToolTipOpen: false
		}
	}
	render(){
		const tooltip_text = {
			"En trámite": 'Tu caso está siendo gestionado por nuestro equipo. El ejecutivo está realizando las gestiones necesarias y te contactará cuando haya novedades.',
			"Pendiente": 'El caso requiere información o documentación de tu parte. Revisa los comentarios del ejecutivo para conocer qué necesitamos para continuar.',
		}
		const colors = {
			"Nuevo" : "blue",
			"Pendiente" : "yellow",
			"En trámite" : "yellow",
			"En proceso" : "yellow",
			"Cerrado" : "green"
		}
		const {children, statusSF} = this.props;
		
		return(
			<div
			onClick={()=>this.setState({ isToolTipOpen: !this.state.isToolTipOpen })}
			data-status-chip-color={ colors[children] ?? colors.Nuevo } 
			className={(Object.hasOwn(tooltip_text,statusSF) ? "cursor-pointer" : "") + " relative"}
			> 
				{children} 
			
				{this.state.isToolTipOpen && Object.hasOwn(tooltip_text, statusSF) &&
					<ToolTipState text={tooltip_text[statusSF]}/>
				}
			</div>
		)
	}
}

/**
* Componente que muestra un globo con informacion adicional.
*
* @class ToolTipState
* @extends Component
*
* @param {Object} props - Propiedades del componente.
* @param {string} props.title - El titulo del tool tip a usar el cual tambien puede ser omitido
* @param {string} props.text - Contenido a renderizar como el cuerpo del tool tip
*
* @example
*	<ToolTipState title="Informacion" text="texto de ayuda" />
*/
class ToolTipState extends Component {
	render(){
		const {title, text} = this.props
		return(
			<div className="header-info-bar header-info-bar--center-bottom mt-0 opened">
				{title && 
					<span className='title'>
						{title}
					</span>
				}
				
				{text}
			</div>
		)
	}
}
